/**
 * 按需引入Vant组件(极大地减少编译后的项目体积)(2021-3-8)
 *
 *
 *
 *
 *
 *
 */
import {
    ActionBar,
    ActionBarButton,
    ActionBarIcon,
    //ActionSheet,
    AddressEdit,
    AddressList,
    Area,
    Badge,
    Button,
    //Calendar,
    //Card,
    //Cascader,
    Cell,
    CellGroup,
    Checkbox,
    CheckboxGroup,
    //Circle,
    //Col,
    //Collapse,
    //Collapse,
    //ContactCard,
    //ContactEdit,
    //ContactList,
    //CountDown,
    //Coupon,
    //CouponCell,
    //CouponList,
    //DatetimePicker,
    //Dialog,
    //Divider,
    DropdownItem,
    DropdownMenu,
    //Empty,
    Field,
    //Form,
    //Grid,
    //GridItem,
    Icon,
    Image,
    //ImagePreview,
    //IndexAnchor,
    //IndexBar,
    //Lazyload,
    List,
    Loading,
    //Locale,
    NavBar,
    NoticeBar,
    //Notify,
    //NumberKeyboard,
    Overlay,
    //Pagination,
    //PasswordInput,
    //Picker,
    //Popover,
    Popup,
    //Progress,
    //PullRefresh,
    //Radio,
    //RadioGroup,
    //Rate,
    //Row,
    Search,
    //ShareSheet,
    //Sidebar,
    //SidebarItem,
    //Skeleton,
    //Slider,
    //Step,
    //Stepper,
    //Steps,
    Sticky,
    SubmitBar,
    Swipe,
    SwipeCell,
    SwipeItem,
    Switch,
    Tab,
    Tabbar,
    TabbarItem,
    Tabs,
    Tag,
    //Toast,
    TreeSelect,
    //Uploader,
} from 'vant';



export default {
    [ActionBar.name]: ActionBar,
    [ActionBarButton.name]: ActionBarButton,
    [ActionBarIcon.name]: ActionBarIcon,
    [AddressEdit.name]: AddressEdit,
    [AddressList.name]: AddressList,
    [Area.name]: Area,
    [Badge.name]: Badge,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [List.name]: List,
    [Loading.name]: Loading,
    [NavBar.name]: NavBar,
    [NoticeBar.name]: NoticeBar,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [SubmitBar.name]: SubmitBar,
    [Swipe.name]: Swipe,
    [SwipeCell.name]: SwipeCell,
    [SwipeItem.name]: SwipeItem,
    [Switch.name]: Switch,
    [Tab.name]: Tab,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tabs.name]: Tabs,
    [Tag.name]: Tag,
    [TreeSelect.name]: TreeSelect,
}
